import { History } from "lucide-react";
import { resultTone } from "./jobMeta";
import { When } from "./When";

/** Last run (Mountain + viewer time), its result, the failure streak and the way into the run history. */
export function LastRunCell({ j, id, onHistory }) {
  const [tone, result] = resultTone(j.last_result, j.last_run_at);
  const platform = j.type === "platform";
  return (
    <td className="px-3 py-3">
      <div className="whitespace-nowrap text-slate-700"><When iso={j.last_run_at} testid={`job-last-${id}`} />
        {j.source === "manual" && <span className="text-[10px] text-slate-400">by hand</span>}</div>
      <div className={`truncate text-[11px] ${tone}`} title={result} data-testid={`job-result-${id}`}>
        {platform ? (j.last_run_at ? "called the app" : "No call recorded yet") : result}</div>
      {j.fail_streak > 0 && (
        <span className={`mt-1 inline-block rounded px-1.5 py-0.5 text-[10px] font-semibold ${j.fail_streak > 1 ? "bg-rose-100 text-rose-800" : "bg-amber-100 text-amber-800"}`}
              data-testid={`job-streak-${id}`} title={j.alert_last ? `Last alert: ${j.alert_last.kind} (${j.alert_last.status})` : undefined}>
          {j.fail_streak > 1 ? `Failed ${j.fail_streak}× in a row` : "Failed last run"}{j.alert_open ? " · alert sent" : ""}</span>)}
      {!platform && (
        <button type="button" onClick={() => onHistory(j)} className="mt-1 flex items-center gap-1 text-[11px] font-medium text-sky-700 hover:underline" data-testid={`job-history-${id}`}>
          <History className="h-3 w-3" /> Run history</button>)}
    </td>
  );
}
